import React from 'react'

/**
 * @param {string} msg  提示文案
 * @param {string|array} btn  按钮文案 或 按钮配置 [{name: '', onBtnClick: function() {}}, ...]
 * @param {string} jump 跳转链接
 * @param {boolean} hideClose 是否隐藏关闭按钮
 * @param {function} onClose 关闭函数
 * @param {boolean} useDefaultMsgDom 是否使用默认提示语 DOM 结构
 */
function TipPop(props) {
    let { msg,  btn, jump,  hideClose, onClose, useDefaultMsgDom, } = props
    btn = btn ? btn : '确定' // 防止传空串

    const dangerousInnerHTML = {
      __html: msg
    }
    let renderBtn = null
    if (typeof btn === 'string') {
      renderBtn = <div className="oc-pop-btnbox">
          {
            jump
              ? <a href={jump} className="btn-oc">{btn}</a>
              : <a href="javascript:;" className="btn-oc" onClick={onClose}>{btn}</a>
          }
        </div>
    } else if (Array.isArray(btn)) {
      renderBtn = <div className="oc-pop-btnbox">
            {
              btn.map((item, index) => {
                return <a key={index} href="javascript:;" className={`btn-oc ${index === 0 ? 'btn-oc-line' : ''}`} onClick={item.onBtnClick}>{item.name}</a>
              })
            }
        </div>
    }
    const msgDom = useDefaultMsgDom ?
            <div className="oc-pop-text oc-tb-cell">
              {
                msg.length <= 15
                  ? <h3>{msg}</h3>
                  : <div dangerouslySetInnerHTML={dangerousInnerHTML}></div>
              }
            </div> :
            <div className="oc-pop-text oc-tb-cell">
              {msg}
            </div>

    return (
      <div className="oc-pop">
        <div className="oc-pop-wp">
          <div className="oc-pop-textbox oc-tb">
            { msgDom }
          </div>
          { btn !== 'hide' && renderBtn }
          { hideClose ? null : <a href="javascript:;" className="oc-pop-close" onClick={onClose}>t('close')</a> }
        </div>
      </div>
    )
  }

  TipPop.defaultProps = {
    msg: '',
    btn: '确定',
    jump: '',
    useDefaultMsgDom: true,
    hideClose: false,
    onClose: function() {}
  }

  function TipLoadingPop(props) {
    return (
      <div className="oc-pop">
        <div className="oc-pop-wp">
          <div className="oc-pop-textbox oc-tb">
            <div className="oc-pop-text oc-tb-cell">
              {
                props.msg.length <= 15
                  ? <h3>{props.msg}</h3>
                  : <div>{props.msg}</div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

export {
  TipPop,
  TipLoadingPop
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/Pops.jsx